import { useSelector } from 'react-redux'
import type { State } from '../../Slice/index.js'
import { applicationSlice } from '../../Slice/Application/ApplicationSlice.js'

export const useGetMessages = () => {
  return useSelector(selectMessages)
}

const selectMessages = (state: typeof State) => state[applicationSlice.name].messages
